/**
 * 住院医生路由
 */
var basePath = 'inpatient-doctor'
const inpatientDoctorRouters = [
  {
    path: `${basePath}/area-patient-list`,
    name: `${basePath}/area-patient-list`,
    meta: {
      title: '住院管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/inpatient-doctor/area-patient-list.vue'], resolve)
  },
  {
    path: `${basePath}/leave-hospital`,
    name: `${basePath}/leave-hospital`,
    meta: {
      title: '出院查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/inpatient-doctor/leave-hospital.vue'], resolve)
  },
  {
    path: `${basePath}/my-drug`,
    name: `${basePath}/my-drug`,
    meta: {
      title: '药嘱配置',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/inpatient-doctor/drug-template.vue'], resolve)
  },
  // {
  //   path: `${basePath}/leave-hospital-tab-medical-record/:inpatient_record_id/:patient_id`,
  //   name: `${basePath}/tab-medical-record`,
  //   meta: {
  //     title: '病案首页',
  //     requiresAuth: true,
  //     nav: {
  //       title: '工作站',
  //       path: '/default/workplace',
  //       children: {
  //         title: '出院查询',
  //         path: `/default/${basePath}/leave-hospital`
  //       }
  //     }
  //   },
  //   component: resolve => require(['../views/page/inpatient-doctor/components/tab-medical-record.vue'], resolve)
  // },
  {
    path: `${basePath}/inpatient-management/:inpatient_record_id/:create_user/:patient_id`,
    name: 'inpatient-management',
    meta: {
      title: '病人病区列表',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '住院管理',
          path: `/default/${basePath}/area-patient-list`
        }
      }
    },
    component: resolve => require(['../views/page/inpatient-doctor/inpatient-management.vue'], resolve)
  },
  {
    path: `${basePath}/inpatient-leave-management/:inpatient_record_id/:patient_id`,
    name: 'inpatient-leave-management',
    meta: {
      title: '出院病人列表',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '出院查询',
          path: `/default/${basePath}/leave-hospital`
        }
      }
    },
    component: resolve => require(['../views/page/inpatient-doctor/inpatient-management.vue'], resolve)
  },
  {
    path: `${basePath}/inpatient-add-inspenction-sheet`,
    name: 'inpatient-add-inspenction-sheet',
    meta: {
      title: '新增验单',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/inpatient-doctor/inpatient-add-inspenction-sheet.vue'], resolve)
  },
  {
    path: `${basePath}/inpatient-add-curelist`,
    name: 'inpatient-add-curelist',
    meta: {
      title: '新增治疗单',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/inpatient-doctor/inpatient-add-curelist.vue'], resolve)
  },
  {
    path: `${basePath}/inpatient-advice-modify/:inpatient_record_id/:create_user/:patient_id`,
    name: 'inpatient-advice-modify',
    meta: {
      title: '医嘱维护',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/inpatient-doctor/manager/advice-modify.vue'], resolve)
  }
]

export default inpatientDoctorRouters
